var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18H4.5C3.30653 18 2.16193 17.5259 1.31802 16.682C0.474106 15.8381 0 14.6935 0 13.5V4.5C0 3.30653 0.474106 2.16193 1.31802 1.31802C2.16193 0.474106 3.30653 0 4.5 0H21.5C22.6935 0 23.8381 0.474106 24.682 1.31802C25.5259 2.16193 26 3.30653 26 4.5V13.5C26 14.6935 25.5259 15.8381 24.682 16.682C23.8381 17.5259 22.6935 18 21.5 18ZM4.5 1C3.57174 1 2.6815 1.36875 2.02513 2.02513C1.36875 2.6815 1 3.57174 1 4.5V13.5C1 14.4283 1.36875 15.3185 2.02513 15.9749C2.6815 16.6313 3.57174 17 4.5 17H21.5C22.4283 17 23.3185 16.6313 23.9749 15.9749C24.6313 15.3185 25 14.4283 25 13.5V4.5C25 3.57174 24.6313 2.6815 23.9749 2.02513C23.3185 1.36875 22.4283 1 21.5 1H4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.7702C12.6833 11.7695 12.3751 11.6679 12.12 11.4802L0.540035 3.12015C0.432623 3.04191 0.36069 2.92421 0.340061 2.79293C0.319432 2.66166 0.351797 2.52757 0.430036 2.42015C0.508274 2.31274 0.625978 2.24081 0.757254 2.22018C0.888529 2.19955 1.02262 2.23191 1.13004 2.31015L12.71 10.6702C12.7947 10.7304 12.8961 10.7628 13 10.7628C13.104 10.7628 13.2054 10.7304 13.29 10.6702L24.89 2.30015C24.9974 2.22191 25.1315 2.18955 25.2628 2.21018C25.3941 2.23081 25.5118 2.30274 25.59 2.41015C25.6683 2.51757 25.7006 2.65166 25.68 2.78293C25.6594 2.91421 25.5874 3.03191 25.48 3.11015L13.88 11.4902C13.6238 11.6743 13.3156 11.7724 13 11.7702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.3657389c913e328eac049f8db8d74a92.svg";
export { ForwardRef as ReactComponent };